import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { STATUS_OPTIONS } from './statusOptions';
import './StatusDropdown.css';

function StatusDropdown({ taskId, currentStatus, onStatusSelect, onClose, position }) {
  const dropdownRef = useRef(null);
  const [resolvedPosition, setResolvedPosition] = useState(null);

  useLayoutEffect(() => {
    if (!position || !dropdownRef.current) return;
    const height = dropdownRef.current.getBoundingClientRect().height;
    const spaceBelow = window.innerHeight - position.y;
    const triggerRect = position.triggerRect;
    if (spaceBelow < height && triggerRect) {
      setResolvedPosition({
        x: position.x,
        top: triggerRect.top - height - 4
      });
    } else {
      setResolvedPosition({
        x: position.x,
        top: position.y
      });
    }
  }, [position]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const handleStatusClick = (status, e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    onStatusSelect(taskId, status);
    onClose();
  };

  const style = position ? {
    position: 'fixed',
    left: `${(resolvedPosition ?? { x: position.x }).x}px`,
    top: `${(resolvedPosition ?? { top: position.y }).top}px`,
    zIndex: 10000,
    visibility: resolvedPosition != null ? 'visible' : 'hidden'
  } : {};

  const dropdownContent = (
    <div ref={dropdownRef} className="status-dropdown text-non-selectable" style={style}>
      {STATUS_OPTIONS.map(option => {
        const isActive = currentStatus === option.value || (currentStatus === null && option.value === 'incomplete') || (currentStatus === undefined && option.value === 'incomplete');
        return (
          <button
            key={option.value}
            className={`status-dropdown-item text-non-selectable ${isActive ? 'status-dropdown-item-active' : ''}`}
            onClick={(e) => handleStatusClick(option.value, e)}
            onMouseDown={(e) => e.stopPropagation()}
            style={{ '--status-color': option.color }}
          >
            <span className="status-dropdown-icon" style={{ color: option.color }}>
              {option.icon}
            </span>
            <span className="status-dropdown-label">{option.label}</span>
            {isActive && (
              <span className="status-dropdown-checkmark">
                <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8 L6 11 L13 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            )}
          </button>
        );
      })}
    </div>
  );

  // Render using portal to ensure it's above all other elements
  return createPortal(dropdownContent, document.body);
}

export default StatusDropdown;

